// 실시간 스캔 결과 스토어 — 검사 로그 + 활동 로그 공유 상태
import { create } from 'zustand';
import type { ActivityType } from './seedData';

export type ScanStatus = 'pending' | 'scanning' | 'safe' | 'quarantine' | 'blocked' | 'failed';
export type ScanSource = 'real';

export interface ScanJob {
  fileId: string;
  filename: string;
  size: string;
  policy: string;
  status: ScanStatus;
  engines: string;
  source: ScanSource;
  time?: string;
}

export interface ActivityEntry {
  time: string;
  type: ActivityType;
  html: string;
}

const MAX_JOBS = 200;
const MAX_ACTIVITY = 500;

interface ScanState {
  jobs: ScanJob[];
  activityEntries: ActivityEntry[];
  addJob: (job: ScanJob) => void;
  updateFileId: (oldId: string, newId: string) => void;
  updateJobStatus: (fileId: string, status: ScanStatus, engines: string) => void;
  addActivity: (type: ActivityType, html: string) => void;
}

export const useScanStore = create<ScanState>((set) => ({
  jobs: [],
  activityEntries: [],

  addJob: (job) =>
    set((s) => ({
      jobs: [
        { ...job, time: job.time ?? new Date().toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) },
        ...s.jobs,
      ].slice(0, MAX_JOBS),
    })),

  updateFileId: (oldId, newId) =>
    set((s) => ({
      jobs: s.jobs.map((j) => j.fileId === oldId ? { ...j, fileId: newId } : j),
    })),

  updateJobStatus: (fileId, status, engines) =>
    set((s) => ({
      jobs: s.jobs.map((j) => j.fileId === fileId ? { ...j, status, engines } : j),
    })),

  addActivity: (type, html) =>
    set((s) => ({
      activityEntries: [
        { time: new Date().toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }), type, html },
        ...s.activityEntries,
      ].slice(0, MAX_ACTIVITY),
    })),
}));
